<template>
  <div @click="hideMe" class="menu-overlay has-background-primary is-vertical-center" v-show="visible">
    <div class="has-text-centered is-fullwidth is-size-3">
      <p><router-link :to="{ name: 'Home'}" class="has-text-white">{{ 'Home' | translate }}</router-link></p>
      <p><router-link :to="{ name: 'Profile'}" class="has-text-white">{{ 'Profile' | translate }}</router-link></p>
      <p><router-link :to="{ name: 'Training'}" class="has-text-white">{{ 'Training' | translate }}</router-link></p>
      <p><router-link :to="{ name: 'EatingPlan'}" class="has-text-white">{{ 'Eating plan' | translate }}</router-link></p>
      <p><router-link :to="{ name: 'Statisitc'}" class="has-text-white">{{ 'Statisitc' | translate }}</router-link></p>
      <p><router-link v-if=" ! $store.getters.isWomanPortal" :to="{ name: 'TrainingList'}" class="has-text-white">{{ 'Workouts List' | translate }}</router-link></p>
    </div>
    <div class="close-icon">
      <img src="@/../static/svg/cancel-white.svg" class="is-medium icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: ['show'],
  data () {
    return {
      visible: this.show
    }
  },
  methods: {
    showMe() {
      this.visible = true
    }, 
    hideMe() {
      this.visible = false
    }
  }
}
</script>

<style>
.menu-overlay {
  position:fixed;
  top:0;
  right:0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}
.close-icon {
  opacity:0.7;
  position:absolute;
  top:1rem;
  right:0.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue